var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("checkout:global.awards.title")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "benefits-images" },
      _vm._l(_vm.trustSymbols, function (trustSymbol) {
        return _c("div", { key: trustSymbol.id }, [
          _c("img", {
            attrs: { src: trustSymbol.image, title: trustSymbol.title },
          }),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }